var map = {
	"./Bixi.png": 37935,
	"./Elephant.png": 39296,
	"./Fire Horse.png": 44865,
	"./Hedgehog.png": 38167,
	"./Huye.png": 64229,
	"./Jiaotu.png": 81218,
	"./Kamaja.png": 75161,
	"./Kirin.png": 64899,
	"./Phoenix.png": 94699,
	"./Shishi.png": 52794,
	"./Spring cattle.png": 37450,
	"./Suanni.png": 74512,
	"./Sword Lion.png": 73587,
	"./bat.png": 16113,
	"./dragon.png": 7109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66091;